const API_URL = import.meta.env.VITE_API_URL || 'https://sellersapi.iremedy.com/graphql';

const TOKEN_KEY = 'd2p_token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export async function gqlRequest(query, variables = {}, { requireAuth = false } = {}) {
  const headers = {
    'Content-Type': 'application/json'
  };

  const token = getToken();
  if (token) {
    headers['Authorization'] = token;
  } else if (requireAuth) {
    throw new Error('AUTH_REQUIRED');
  }

  const response = await fetch(API_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify({ query, variables })
  });

  const result = await response.json();

  if (result.errors && result.errors.length > 0) {
    const error = new Error(result.errors[0].message);
    error.graphqlErrors = result.errors;
    throw error;
  }

  return result.data;
}
